export const buildRelatedProductSearchFilters = (relatedBrands = [], relatedCategory = null) => {
  const brandIds = relatedBrands.map((brand) => brand.id)
  const productFilter = relatedCategory?.related_product_filter

  if (!productFilter) {
    return {
      catalogSources: ['premium', 'outlet'],
      brandIds,
      categoryIds: null,
      subcategoryIds: null,
    }
  }

  return {
    catalogSources: productFilter.catalogSources,
    brandIds,
    categoryIds: productFilter.categoryIds,
    subcategoryIds: productFilter.subcategoryIds,
  }
}

export default buildRelatedProductSearchFilters
